import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { Utils } from 'src/app/shared/commons/Utils';
import { AddressTypeEnum } from 'src/app/shared/enums/address-type.enum';
import { ApisEnum } from 'src/app/shared/enums/apis.enum';
import { AccountModel } from 'src/app/shared/interfaces/account-model';
import { AddressModel } from 'src/app/shared/interfaces/address-model';
import { ClientModel } from 'src/app/shared/interfaces/client-model';
import { AddressService } from 'src/app/shared/services/address.service';
import { ClientService } from 'src/app/shared/services/client.service';
import { UtilService } from 'src/app/shared/services/util.service';
@Component({
  selector: 'app-address-card-dialog',
  templateUrl: './address-card-dialog.component.html',
  styleUrls: ['./address-card-dialog.component.scss']
})
export class AddressCardDialogComponent implements OnInit {

  address = {} as AddressModel
  account = {} as AccountModel
  client = {} as ClientModel
  formGroup: UntypedFormGroup
  confirmResult: Subject<boolean | string>
  requestCard: boolean
  listUFs: any = []
  cities: any = []

  constructor(
    public modalRef: BsModalRef,
    private formBuilder: UntypedFormBuilder,
    private addressService: AddressService,
    private clientService: ClientService,
    private utilService: UtilService,
  ) { }

  async ngOnInit() {
    this.clientService.clientData.subscribe(d => {
      if (!d) { return }
      this.client = d
    })
    this.clientService.accountData.subscribe(d => {
      if (!d) { return }
      this.account = d
    })
    this.confirmResult = new Subject()
    this.buildForm()
    await this.getAddress()
    await this.getEstates()
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      zip_code: ['', Validators.compose([Validators.required, Validators.minLength(9)])],
      street: ['', Validators.required],
      street_number: [''],
      state: ['', Validators.required],
      district: ['', Validators.required],
      city: ['', Validators.required],
      type: [AddressTypeEnum.comercial],
      complement: ['']
    })
  }

  setFormValues(address) {
    if (address?.street_number == 'S/N')
      address.street_number = ''

    this.f.zip_code.setValue(Utils.maskZipCode(address.zip_code || address.cep))
    this.f.street.setValue(address.street || address.logradouro)
    this.f.street_number.setValue(address?.street_number)
    this.f.state.setValue(address.state || address.uf)
    this.f.district.setValue(address.district || address.bairro)
    this.f.city.setValue(address.city || address.localidade)
    this.f.complement.setValue(address.complement)
    this.formGroup.markAllAsTouched()
  }

  async getAddress() {
    this.address = {} as AddressModel
    const result = await this.addressService.read(ApisEnum.Client)
    if (result?.addresses) {
      this.address = result.addresses.filter(x => x.id !== undefined).shift()
      this.setFormValues(this.address)
    }
  }

  getZipCode(event) {
    const zip_code = Utils.unMask(event.target.value)
    if (event.key !== "Backspace" && zip_code != undefined && zip_code.length === 8) {
      this.addressService.readByCep(Utils.maskZipCode(zip_code)).then(result => {
        this.setFormValues(result)
        this.utilService.mark_controls_dirty(this.formGroup.controls)
      })
    }
  }

  async getEstates() {
    this.listUFs = await this.addressService.readUFs()
    if (this.address.state) {
      await this.getCities(this.address.state)
    }
  }

  async getCities(state) {
    this.cities = await this.addressService.readCountiesById(state)
  }

  onGetCities(e: any) {
    this.getCities(e.target.value)
  }

  next() {
    try {
      if (this.formGroup.valid) {
        const addressData = Object.assign({} as any, this.utilService.dirty_controls_data(this.formGroup.controls))
        if (Object.keys(addressData).length > 0) {
          if (!addressData?.street_number)
            addressData.street_number = 'S/N'

          if (!addressData.zip_code || (Utils.unMask(this.address.zip_code) != Utils.unMask(addressData.zip_code))) {
            this.updateAddress(addressData)
          } else {
            this.saveAddress(addressData)
          }
        } else {
          if (this.requestCard)
            this.newCard(this.address.id)
          else
            this.close(true)
        }
      } else {
        this.formGroup.markAllAsTouched()
      }
    } catch (error) {
      this.close(false)
    }
  }

  saveAddress(addressData) {
    addressData.zip_code = Utils.unMask(addressData.zip_code)
    addressData.name = 'Home'
    addressData.country = 'Brazil'
    this.addressService.create(ApisEnum.Client, addressData).then(res => {
      this.address = res
      if (this.requestCard)
        this.newCard(this.address.id)
      else
        this.close(true)
    })
  }

  updateAddress(addressData) {
    this.addressService.update(ApisEnum.Client, this.address.id, addressData).then(res => {
      this.address = res
      if (this.requestCard)
        this.newCard(this.address.id)
      else
        this.close(true)
    })
  }

  newCard(address_id) {
    const in_body = {
      card_type: 'main',
      delivery_address_id: address_id,
      gender: 'female'
    }
    this.clientService.saveCard(this.client.uuid, this.account.uuid, in_body).then(res => {
      if (res.error)
        this.close(false)
      else
        this.close(true)
    })
  }

  close(value) {
    this.confirmResult.next(value)
    this.modalRef.hide()
  }

  // convenience getter for easy access to form fields
  get f() { return this.formGroup.controls }
}
